import type { PageFaq } from "@/lib/pages";
import { RoundupLandingPage } from "@/components/compare-landing/roundup-landing-page";
import { empowerAlternativesConfig } from "./compare-empower-alternatives-config";

/**
 * Config-driven roundup landing page for `/compare/empower-alternatives`.
 * Both locale entry routes render this component; its SEO meta comes from the
 * locale-aware markdown frontmatter in `pages/compare/empower-alternatives.md`
 * via the sibling `compare-empower-alternatives.meta.ts`.
 */
export function EmpowerAlternativesComponent({
  faqs,
  offersAsOf,
}: {
  faqs?: PageFaq[];
  offersAsOf: string;
}) {
  return (
    <RoundupLandingPage
      config={empowerAlternativesConfig}
      faqs={faqs}
      offersAsOf={offersAsOf}
    />
  );
}
